
class NewsletterSignup {
  constructor () {

    let nFooter = document.querySelector('.js-newsletter-signup-footer')

    if(nFooter) {
      this.initElement(nFooter)
    }
  }

  initElement (element) {
    let input = element.getElementsByTagName('input')[0]
    element.getElementsByTagName('button')[0].addEventListener('click', event => {
      event.preventDefault()
      window.open('https://shipcologne.us19.list-manage.com/subscribe?u=32b64704e60cc15e6c69cf9e0&id=cacf4ea4bf&MERGE0=' + input.value, '_blank')
    })
  }

}

export default new NewsletterSignup()
